import { Modal } from 'antd'
import React from 'react'

const  CustomModal = ({open, title, destroyOnClose=false, ...restProps}) => {
  return (
    <Modal
      open={open} 
      title={title}
      footer={null}
      destroyOnClose={destroyOnClose}
      {...restProps}
    >
    </Modal>
  )
}

CustomModal.useModal = Modal.useModal;   
export default CustomModal